/**
 * 照片验证状态码映射表
 *
 * 状态码结构说明:
 * - 0: 验证通过
 * - 100到103: 真实照片(位置验证有不同状态)
 * - -6001到-6007: 虚假照片(时间/位置验证失败)
 * - -7001到-7006: 虚假照片(图片验证失败)
 * - -2303: 等待上传验证
 * - 其他: 无法验证
 *
 * 图标状态类型:
 * - success: 验证通过(绿色对勾)
 * - warning: 验证警告(灰色感叹号)
 * - error: 验证失败(红色叉号)
 * - weak: 无需验证(灰色对勾)
 *
 * 消息结构:
 * - type: 整体验证结果('success'|'error'|'unavailable')
 * - message: 验证详情对象
 *   - time: 时间验证结果
 *   - location: 位置验证结果
 *   - image: 图片验证结果
 *   每个验证结果包含:
 *   - iconStatus: 图标类型
 *   - message: 国际化消息key(仅error/warning状态需要)
 *   - hasServer: 是否需要服务端数据(默认true)
 */
import DefaultImg from './assets/unableToVerifyImg.png'
const SUCCESS_ICON = { iconStatus: 'success' }
const WEAK_ICON = { iconStatus: 'weak' }
const ERROR_ICON = (message, hasServer = true) => ({
  iconStatus: 'error',
  message,
  hasServer
})
const WARNING_ICON = (message, hasServer = false) => ({
  iconStatus: 'warning',
  message,
  hasServer
})

const createMessage = (time, location, image) => ({ time, location, image })

export const CODE_STATUS_MAPPING = {
  // 验证为真
  0: {
    type: 'success',
    message: createMessage(SUCCESS_ICON, SUCCESS_ICON, SUCCESS_ICON)
  },
  101: {
    type: 'success',
    message: createMessage(
      SUCCESS_ICON,
      { ...WARNING_ICON('i_verify_location_notenable') },
      SUCCESS_ICON
    )
  },
  102: {
    type: 'success',
    message: createMessage(
      SUCCESS_ICON,
      { ...WARNING_ICON('i_verify_location_authorization') },
      SUCCESS_ICON
    )
  },
  103: {
    type: 'success',
    message: createMessage(
      SUCCESS_ICON,
      { ...WARNING_ICON('i_verify_location_retrieval_failed') },
      SUCCESS_ICON
    )
  },
  104: {
    type: 'success',
    message: createMessage(
      SUCCESS_ICON,
      { ...WARNING_ICON('i_verify_location_retrieval_failed') },
      SUCCESS_ICON
    )
  },
  // 验证为假 - 时间/位置/图片验证失败
  '-8003': {
    type: 'error',
    message: createMessage(
      { ...WARNING_ICON() },
      { ...WARNING_ICON() },
      { ...ERROR_ICON('i_verify_image_processed') }
    )
  },
  '-8004': {
    type: 'unavailable',
    message: {
      title: '',
      content: 'i_unable_cheating_tampering',
      customComponent: (
        <div
          style={{ color: '#8B4D4D', fontWeight: 500, fontSize: '20px' }}
        ></div>
      )
    }
  },
  '-6002': {
    type: 'error',
    message: createMessage(
      ERROR_ICON('i_verify_time_original', true),
      { ...WARNING_ICON('i_verify_location_notenable') },
      WEAK_ICON
    )
  },
  '-6003': {
    type: 'error',
    message: createMessage(
      { ...ERROR_ICON('i_verify_time_original', true) },
      { ...ERROR_ICON('i_verify_location_original', true) },
      WEAK_ICON
    )
  },
  '-6005': {
    type: 'error',
    message: createMessage(
      WEAK_ICON,
      ERROR_ICON('i_verify_location_original', true),
      WEAK_ICON
    )
  },
  '-6006': {
    type: 'error',
    message: createMessage(
      ERROR_ICON('i_verify_time_original', true),
      WEAK_ICON,
      WEAK_ICON
    )
  },
  '-7001': {
    type: 'error',
    message: createMessage(
      WEAK_ICON,
      WARNING_ICON('i_verify_location_notenable'),
      ERROR_ICON('i_verify_image_processed')
    )
  },
  '-7002': {
    type: 'error',
    message: createMessage(
      ERROR_ICON('i_verify_time_original'),
      WARNING_ICON('i_verify_location_notenable'),
      ERROR_ICON('i_verify_image_processed')
    )
  },
  '-7003': {
    type: 'error',
    message: createMessage(
      ERROR_ICON('i_verify_time_original'),
      ERROR_ICON('i_verify_location_original'),
      ERROR_ICON('i_verify_image_processed')
    )
  },
  '-7004': {
    type: 'error',
    message: createMessage(
      WEAK_ICON,
      ERROR_ICON('i_verify_location_original'),
      ERROR_ICON('i_verify_image_processed')
    )
  },
  '-7005': {
    type: 'error',
    message: createMessage(
      ERROR_ICON('i_verify_time_original'),
      WEAK_ICON,
      ERROR_ICON('i_verify_image_processed')
    )
  },
  '-7006': {
    type: 'error',
    message: createMessage(
      WEAK_ICON,
      WEAK_ICON,
      ERROR_ICON('i_verify_image_processed')
    )
  },
  // 其他无法验真的小类
  '-2307': {
    type: 'unavailable',
    message: {
      title: 'i_verify_uable_waiting_upload',
      content: 'i_verify_uable_open_timemark'
    }
  },
  '-2301': {
    type: 'unavailable',
    message: {
      title: 'i_verify_uable_general',
      content: 'i_only_photo_sidecode_sligible',
      imgUrl: DefaultImg
    }
  },
  '-2305': {
    type: 'unavailable',
    message: {
      title: 'i_photo_cant_verify_without_template',
      content: ''
    }
  },
  other: {
    type: 'unavailable',
    message: {
      title: 'i_verify_uable_general',
      content: ''
    }
  }
}
